function IsHybridApp() {
    return $('#app-data').length > 0;
}

module.exports = IsHybridApp;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/is-hybrid-app.js